import { Box, Grid2 } from '@mui/material';
import { bck_login } from '../../../assets';
import useWhiteLabelService from '../../../layout/login/hooks/useWhiteLabel.service';
import LogoController from '../../../layout/login/components/LogoController/LogoController';
import AuthLayoutStyles from './AuthLayout.styles';
import { AuthLayoutProps } from './AuthLayout.types';

export const AuthLayout = ({
  children,
  headerActions,
  className,
  showImage = true,
}: AuthLayoutProps) => {
  const { whiteLabelState } = useWhiteLabelService();
  const isWhiteLabel = !!whiteLabelState?.organizationID;

  return (
    <div className={`${AuthLayoutStyles.container} ${className || ''}`}>
      <Box className={AuthLayoutStyles.header}>
        <LogoController
          isWhiteLabel={isWhiteLabel}
          efexLogoProps={{ className: AuthLayoutStyles.logoContainer }}
          whiteLabelLogo={whiteLabelState.organizationLogoURL}
        />
        {headerActions && (
          <div className={AuthLayoutStyles.headerActions}>{headerActions}</div>
        )}
      </Box>

      <Grid2 className={AuthLayoutStyles.mainGrid} container>
        <Grid2
          size={{ xs: 12, md: showImage ? 6 : 12 }}
          className={AuthLayoutStyles.formSection}
        >
          {children}
        </Grid2>

        {showImage && (
          <Grid2
            size={{ xs: 12, md: 6 }}
            className={AuthLayoutStyles.imageSection}
          >
            <img
              src={bck_login}
              alt="Background"
              className={AuthLayoutStyles.backgroundImage}
            />
          </Grid2>
        )}
      </Grid2>
    </div>
  );
};

export default AuthLayout;
